import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getMaintenancesToDevices } from "@/api/resources/maintenancesToDevices/api";
import i18n from "@/providers/i18n";

const entities = i18n.t("data");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const maintenancesToDevicesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "maintenancesToDevices"],
  byMaintenance: (maintenance_id?: string) => [
    ...maintenancesToDevicesQueryKeys.all(),
    "byMaintenance",
    maintenance_id,
  ],
};

export const maintenancesToDevicesQueries = {
  byMaintenance: (maintenance_id?: string) =>
    queryOptions({
      queryKey: [...maintenancesToDevicesQueryKeys.byMaintenance(maintenance_id)],
      queryFn: maintenance_id ? () => getMaintenancesToDevices(maintenance_id) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
};
